import { createSelector } from 'reselect';
import type { SortDirection } from '@atlassian/jira-common-constants/src/sort-directions.tsx';
import type { Filter, Project, Group, Owner, Query } from '../../../model/index.tsx';
import type { SortField } from '../../../model/sort-field.tsx';
import type { State } from '../../types.tsx';

export const getQuery = (state: State): Partial<Query> => state.query;

export const getSortField = (state: State): SortField => state.query.sortField;
export const getSortDirection = (state: State): SortDirection => state.query.sortDirection;
export const getPage = (state: State): number => state.query.page;

export const getFilter = (state: State): Filter | undefined => state.query.filter;
export const getSearchQuery = (state: State): string => getFilter(state)?.query || '';
export const getSelectedProject = (state: State): Project | undefined => getFilter(state)?.project;
export const getSelectedGroup = (state: State): Group | undefined => getFilter(state)?.group;
export const getSelectedOwner = (state: State): Owner | undefined => getFilter(state)?.owner;

export const isFilterApplied = createSelector(
	getSearchQuery,
	getSelectedProject,
	getSelectedGroup,
	getSelectedOwner,
	(queryValue, projectValue, groupValue, ownerValue) =>
		!!queryValue || !!projectValue || !!groupValue || !!ownerValue,
);
